import { Box, Button, Icon, IconButton, Spacer, Text } from '@homebotapp/hb-react-component-catalog'
import { useEffect, useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'

export const MSG = defineMessages({
  drawerHeaderTitle: {
    id: 'MobileShortcutsDrawer.drawerHeader.title',
    defaultMessage: 'Shortcuts'
  },
  expandAriaLabel: {
    id: 'MobileShortcutsDrawer.toggleButton.expandAriaLabel',
    defaultMessage: 'Expand Shortcuts Drawer'
  },
  collapseAriaLabel: {
    id: 'MobileShortcutsDrawer.toggleButton.collapseAriaLabel',
    defaultMessage: 'Collapse Shortcuts Drawer'
  }
})

const TRACKING_GUID = 'kKjHkcQeaUZZUXXwjRFkoF'

export const DrawerButton = ({ onClick, isOpen, ...props }) => {
  const intl = useIntl()
  const expandedAriaLabel = intl.formatMessage(MSG.expandAriaLabel)
  const collapsedAriaLabel = intl.formatMessage(MSG.collapseAriaLabel)

  const [transform, setTransform] = useState('rotate(0deg)')

  // Transitions run before the page loads,  so we need to wait
  // until the page loads to set the transform.
  useEffect(() => {
    setTransform(isOpen ? 'rotate(180deg)' : 'rotate(0deg)')
  }, [isOpen])

  return (
    <Button
      {...props}
      onClick={onClick}
      width='100%'
      display='flex'
      paddingY='7'
      variant='ghost'
      tracking={{
        guid: TRACKING_GUID,
        descriptor: 'Mobile Shortcuts Drawer Toggle Button'
      }}
      aria-label={isOpen ? collapsedAriaLabel : expandedAriaLabel}
    >
      <Text as='span' color='neutral-900'>
        {intl.formatMessage(MSG.drawerHeaderTitle)}
      </Text>
      <Spacer />
      <IconButton
        as={Box}
        aria-label={isOpen ? collapsedAriaLabel : expandedAriaLabel}
        icon={<Icon name='angle-up' transitionProperty='transform' transitionDuration='normal' transform={transform} />}
        isRound
        size='xs'
      />
    </Button>
  )
}
